<template>
    <div>
        <!-- <div v-if="noticeVisible" class="pc-notice-bar-wrap"> -->
        <!-- <van-notice-bar
      :text="noticeText"
      :background="noticeBarBgColor"
      color="#fff"
      left-icon="volume-o"
    />
    <div class="pc-notice-buy-btn" @click="openBuyModal">购买授权</div> -->

        <!-- 购买授权弹窗 -->
        <div v-if="showBuyModal" class="pc-buy-modal-overlay" @click.self="closeBuyModal">
            <div class="pc-buy-modal">
                <div class="pc-buy-header">
                    <span class="pc-buy-title">购买授权</span>
                    <van-icon name="cross" class="pc-buy-close" @click="closeBuyModal" />
                </div>

                <div v-if="isPriceLoading" class="pc-buy-loading">
                    <van-loading color="#FE724F" />
                    <span style="margin-left:0.15rem;">正在获取价格…</span>
                </div>

                <!-- 未生成二维码：展示说明和价格 -->
                <template v-if="!payQrCodeUrl && !isPriceLoading">
                    <!-- 服务端错误提示 -->
                    <div v-if="errMsg" class="pc-buy-error-notice">
                        <van-icon name="warning-o" class="pc-buy-notice-icon" style="color:#ff4d4f" />
                        <span class="pc-buy-notice-text" style="color:#cc3333">{{ errMsg }}</span>
                    </div>
                    <!-- 信息提示框（仿移动端样式） -->
                    <div class="pc-buy-notice">
                        <van-icon name="info-o" class="pc-buy-notice-icon" />
                        <span class="pc-buy-notice-text">{{ noticeModalText }}</span>
                    </div>
                    <!-- 价格行 -->
                    <div class="pc-buy-price-row">
                        <span class="pc-buy-price-label">授权费用</span>
                        <span class="pc-buy-price-value">¥{{ authPrice }} 元</span>
                    </div>
                    <div class="pc-buy-tip">支付成功后系统将自动授权</div>
                </template>

                <!-- 已生成二维码 -->
                <template v-if="payQrCodeUrl">
                    <div class="pc-qrcode-area">
                        <div class="pc-buy-price-display">¥ {{ Number(authPrice).toFixed(2) }}</div>
                        <div class="pc-buy-memo-tip">请使用微信 / 支付宝扫码完成支付，支付过程中请勿关闭此窗口</div>
                        <div class="pc-qrcode-wrap">
                            <img :src="payQrCodeUrl" class="pc-qrcode-img" alt="支付二维码" />
                        </div>
                        <div class="pc-qrcode-status" :class="payStatus === 1 ? 'success' : 'waiting'">
                            <template v-if="payStatus === 0">
                                <span class="pc-status-dot"></span>
                                <span>等待扫码支付...</span>
                            </template>
                            <template v-if="payStatus === 1">
                                <van-icon name="checked" color="#19be6b" size="0.35rem" />
                                <span style="margin-left:0.1rem;">支付成功，授权已开通！</span>
                            </template>
                        </div>
                    </div>
                </template>

                <div class="pc-buy-buttons">
                    <button class="pc-btn-cancel" @click="closeBuyModal">取消</button>
                    <button class="pc-btn-confirm" :disabled="isPayLoading || payStatus === 1"
                        @click="!payQrCodeUrl ? initiatePayment() : null">
                        {{ isPayLoading ? '生成中...' : (payStatus === 1 ? '已支付' : (payQrCodeUrl ? '等待扫码' : '购买')) }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'PcNoticeBar',
    computed: {
        ...mapGetters({ shop: 'shop' }),
        _badgeStatus() {
            const { is_free, device_bind, trial_end_time } = this.shop || {};
            if (is_free === undefined) return null;
            const hasBind = this._hasDeviceBind(device_bind);
            const isTrialValid = trial_end_time && new Date(trial_end_time) > new Date();
            if (Number(is_free) === 2 && hasBind) return 'auth';
            if (isTrialValid) return 'trial';
            return 'free';
        },
        noticeVisible() {
            return this._badgeStatus === 'trial' || this._badgeStatus === 'free';
        },
        noticeText() {
            if (this._badgeStatus === 'trial') {
                const endTime = this.shop.trial_end_time;
                if (endTime) {
                    const remaining = Math.ceil((new Date(endTime) - new Date()) / (1000 * 60 * 60 * 24));
                    return `【试用版】距试用到期还有 ${remaining} 天，到期后将降为免费版(功能受限)，请联系客服购买授权`;
                }
                return '【试用版】请联系客服购买授权以继续使用全部功能';
            }
            const { trial_end_time, device_bind } = this.shop || {};
            const hasBind = this._hasDeviceBind(device_bind);
            if (!hasBind) {
                return '【免费版】设备未授权，请联系客服购买授权版';
            }
            if (trial_end_time && new Date(trial_end_time) <= new Date()) {
                return '【免费版】试用已结束，部分功能受限，请联系客服购买授权版';
            }
            return '【免费版】试用已结束，菜品、会员、桌位数量上限降为10个，请联系客服购买授权版';
        },
        noticeBarBgColor() {
            return this._badgeStatus === 'trial' ? '#764ba2' : '#999999';
        },
        noticeModalText() {
            if (this._badgeStatus === 'trial') {
                const endTime = this.shop.trial_end_time;
                if (endTime) {
                    const remaining = Math.ceil((new Date(endTime) - new Date()) / (1000 * 60 * 60 * 24));
                    return `您当前处于试用版，距到期还有 ${remaining} 天，到期后功能将受限，请购买授权继续使用全部功能。`;
                }
                return '您当前处于试用版，请购买授权后继续使用全部功能。';
            }
            return '您当前处于免费版，菜品、会员、桌位数量上限为10个，请购买授权解锁全部功能。';
        },
    },
    data() {
        return {
            showBuyModal: false,
            authPrice: 299,
            payQrCodeUrl: '',
            payNum: '',
            pollingTimer: null,
            isPayLoading: false,
            payStatus: 0,
            isPriceLoading: false,
            errMsg: '',
        };
    },
    methods: {
        async openBuyModal(params) {
            this.errMsg = (params && params.errMsg) || '';
            this.showBuyModal = true;
            this.isPriceLoading = true;
            try {
                const res = await this.$api.getAuthPriceList();
                if (res.code === 1 && res.data && res.data.list) {
                    const item = res.data.list.find(i => i.business_type === 5);
                    if (item) this.authPrice = item.price;
                }
            } catch (e) {
                this.$toast('获取价格失败，请重试');
                this.showBuyModal = false;
            } finally {
                this.isPriceLoading = false;
            }
        },
        closeBuyModal() {
            this.stopPolling();
            this.showBuyModal = false;
            this.payQrCodeUrl = '';
            this.payNum = '';
            this.payStatus = 0;
            this.isPayLoading = false;
            this.errMsg = '';
        },
        async initiatePayment() {
            this.isPayLoading = true;
            try {
                const res = await this.$api.generatePayQrcode({
                    total_price: this.authPrice,
                    business_type: 5,
                    order_body: '店掌宝收银端授权',
                });
                if (res.code === 1) {
                    this.payNum = res.data.pay_num;
                    this.payQrCodeUrl = res.data.qrcode_img_url;
                    if (res.data.total_price) this.authPrice = res.data.total_price;
                    this.payStatus = 0;
                    this.startPolling();
                } else {
                    this.$toast(res.msg || '生成二维码失败');
                }
            } catch (e) {
                this.$toast('网络异常，请重试');
            } finally {
                this.isPayLoading = false;
            }
        },
        startPolling() {
            this.stopPolling();
            this.pollingTimer = setInterval(async () => {
                try {
                    const res = await this.$api.queryPayStatus({ pay_num: this.payNum });
                    if (res.code === 1 && res.data.status === 1) {
                        this.payStatus = 1;
                        this.stopPolling();
                        this.$store.dispatch('setShopInfo', {
                            ...this.$store.state.shop,
                            is_free: 2,
                        });
                        this.$toast.success('支付成功，授权已开通');
                        setTimeout(() => this.closeBuyModal(), 1500);
                    }
                } catch (e) { /* 轮询静默 */ }
            }, 3000);
        },
        stopPolling() {
            if (this.pollingTimer) {
                clearInterval(this.pollingTimer);
                this.pollingTimer = null;
            }
        },
        _hasDeviceBind(deviceBind) {
            if (!deviceBind) return false;
            if (Array.isArray(deviceBind)) return deviceBind.includes('pos');
            if (typeof deviceBind === 'string') {
                try {
                    const parsed = JSON.parse(deviceBind);
                    if (Array.isArray(parsed)) return parsed.includes('pos');
                } catch (e) { }
                return deviceBind.split(',').map(s => s.trim()).includes('pos');
            }
            return false;
        },
    },
    created() {
        this.$bus.$on('openAuthBuyModal', this.openBuyModal);
    },
    beforeDestroy() {
        this.$bus.$off('openAuthBuyModal', this.openBuyModal);
        this.stopPolling();
    },
};
</script>

<style lang="less" scoped>
.pc-notice-bar-wrap {
    position: fixed;
    top: 1.2rem;
    left: 2rem;
    width: calc(100vw - 2rem);
    z-index: 150;
    display: flex;
    align-items: stretch;

    /deep/ .van-notice-bar {
        flex: 1;
        min-width: 0;
        padding-right: 1.6rem;
        /* 给购买按钮留空间 */
    }
}

.pc-notice-buy-btn {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    padding: 0 0.2rem;
    background: linear-gradient(135deg, #FF7C5C, #FE724F);
    color: #fff;
    font-size: 0.28rem;
    font-weight: bold;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
        opacity: 0.9;
    }
}

/* 弹窗遮罩 */
.pc-buy-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 3000;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pc-buy-modal {
    background: #fff;
    border-radius: 0.16rem;
    padding: 0.4rem 0.5rem 0.36rem;
    width: 7.5rem;
    box-sizing: border-box;
    position: relative;
}

.pc-buy-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 0.24rem;
    margin-bottom: 0.24rem;
    border-bottom: 1px solid #f0f0f0;
}

.pc-buy-title {
    font-size: 0.38rem;
    font-weight: bold;
    color: #333;
}

.pc-buy-close {
    font-size: 0.36rem;
    color: #999;
    cursor: pointer;

    &:hover {
        color: #333;
    }
}

.pc-buy-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.4rem 0;
    font-size: 0.3rem;
    color: #666;
}

.pc-buy-desc {
    font-size: 0.3rem;
    color: #666;
    line-height: 1.8;
    margin-bottom: 0.24rem;

    p {
        margin: 0;
    }
}

.pc-buy-price-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff8f5;
    border: 1px solid #fde0d6;
    border-radius: 0.12rem;
    padding: 0.2rem 0.28rem;
    margin-bottom: 0.18rem;
}

.pc-buy-price-label {
    font-size: 0.32rem;
    color: #333;
}

.pc-buy-price-value {
    font-size: 0.42rem;
    font-weight: bold;
    color: #fe724f;
}

.pc-buy-tip {
    font-size: 0.26rem;
    color: #999;
    background: #fafafa;
    border-radius: 0.08rem;
    padding: 0.14rem 0.2rem;
    margin-bottom: 0.1rem;
}

/* 二维码区域 */
.pc-qrcode-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0.1rem 0;
}

.pc-buy-price-display {
    font-size: 0.56rem;
    font-weight: bold;
    color: #fe724f;
    margin-bottom: 0.1rem;
}

.pc-buy-memo-tip {
    font-size: 0.26rem;
    color: #999;
    margin-bottom: 0.18rem;
    text-align: center;
}

.pc-qrcode-wrap {
    padding: 0.1rem;
    border: 2px solid #FE724F;
    border-radius: 0.12rem;
    background: #fff;
    box-shadow: 0 4px 16px rgba(254, 114, 79, 0.15);
    margin-bottom: 0.15rem;
}

.pc-qrcode-img {
    width: 3.2rem;
    height: 3.2rem;
    display: block;
}

.pc-qrcode-status {
    display: flex;
    align-items: center;
    font-size: 0.28rem;
    padding: 0.08rem 0.2rem;
    border-radius: 0.2rem;

    &.waiting {
        background: #fff8f0;
        color: #FE724F;
    }

    &.success {
        background: #f0fff4;
        color: #19be6b;
    }
}

.pc-status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #FE724F;
    margin-right: 0.1rem;
    animation: pc-pulse 1.2s ease-in-out infinite;
}

@keyframes pc-pulse {

    0%,
    100% {
        opacity: 1;
        transform: scale(1);
    }

    50% {
        opacity: 0.4;
        transform: scale(0.8);
    }
}

/* 按钮组 */
.pc-buy-buttons {
    display: flex;
    gap: 0.24rem;
    margin-top: 0.28rem;
}

.pc-btn-cancel,
.pc-btn-confirm {
    flex: 1;
    height: 0.76rem;
    line-height: 0.76rem;
    border-radius: 0.38rem;
    font-size: 0.3rem;
    border: none;
    cursor: pointer;
    text-align: center;

    &:focus {
        outline: none;
    }
}

.pc-btn-cancel {
    background: #f0f0f0;
    color: #666;
}

.pc-btn-confirm {
    background: #fe724f;
    color: #fff;
}

.pc-btn-confirm[disabled] {
    background: #f5a98a;
    cursor: not-allowed;
}

/* 新增：信息提示框 */
.pc-buy-notice {
    display: flex;
    align-items: flex-start;
    background: #fff8f5;
    border: 1px solid #fde0d6;
    border-radius: 0.1rem;
    padding: 0.22rem 0.24rem;
    margin-bottom: 0.28rem;

    .pc-buy-notice-icon {
        font-size: 0.38rem;
        color: #FE724F;
        flex-shrink: 0;
        margin-right: 0.14rem;
        margin-top: 0.02rem;
    }

    .pc-buy-notice-text {
        font-size: 0.32rem;
        color: #555;
        line-height: 1.7;
    }
}

/* 按钮改为胶囊形 */
.pc-buy-buttons {
    button {
        border-radius: 0.44rem;
        height: 0.88rem;
        font-size: 0.36rem;
    }
}

.pc-buy-error-notice {
  display: flex;
  align-items: flex-start;
  background: #fff2f0;
  border: 1px solid #ffccc7;
  border-radius: 0.1rem;
  padding: 0.22rem 0.24rem;
  margin-bottom: 0.2rem;

  .pc-buy-notice-icon {
    font-size: 0.38rem;
    flex-shrink: 0;
    margin-right: 0.14rem;
    margin-top: 0.02rem;
  }

  .pc-buy-notice-text {
    font-size: 0.32rem;
    line-height: 1.7;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pcNoticeBar.vue